
// ============================================================================
// POPOVER / POPUP
// ============================================================================

function openPopup(popupId) {
    const popover = document.getElementById(popupId);
    if (popover && !popover.matches(":popover-open")) {
        popover.showPopover();
    }
}

function closePopup(popupId) {
    const popover = document.getElementById(popupId);
    if (popover?.matches(":popover-open")) {
        popover.hidePopover();
    }
}

function isPopupOpen(popupId) {
    const popover = document.getElementById(popupId);
    return popover?.matches(":popover-open") ?? false;
}

/**
 * Closes the popup when focus leaves it for something else — the tab-out case the browser's own
 * light dismiss does not cover.
 *
 * Only a focus move to another element counts. A null relatedTarget means focus went nowhere, which
 * happens every time a re-render removes or disables the control the user just activated; treating
 * that as a dismissal closes popups in the middle of their own actions. Clicks outside are already
 * handled by light dismiss, since the popover is in the auto state.
 */
function setupCloseOnFocusLoss(popupId) {
    const popover = document.getElementById(popupId);
    if (!popover || popover._focusOutHandler) return;

    const handleFocusChange = (event) => {
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null || popover.contains(relatedTarget)) return;

        if (popover.matches(":popover-open")) {
            popover.hidePopover();
        }
    };

    popover._focusOutHandler = handleFocusChange;
    popover.addEventListener('focusout', handleFocusChange);
}

/**
 * Mirrors the popover's open state onto its trigger as aria-expanded.
 *
 * The popover can be opened three ways — the browser's own popovertarget, a JS
 * showPopover(), or a light-dismiss click outside — and only the DOM sees all
 * three. 
 */
function setupTriggerExpandedState(popupId) {
    const popover = document.getElementById(popupId);
    if (!popover || popover._expandedStateHandler) return;

    const trigger =
        document.querySelector(`[popovertarget="${popupId}"]`) ??
        document.querySelector(`[style*="anchor-name: --${popupId}"]`) ??
        popover.previousElementSibling?.querySelector('button, input, [role="combobox"]') ??
        popover.previousElementSibling;

    if (!trigger) return;

    const sync = () =>
        trigger.setAttribute('aria-expanded', popover.matches(':popover-open') ? 'true' : 'false');

    sync();

    popover._expandedStateHandler = sync;
    popover.addEventListener('toggle', sync);
}

globalThis.popup = {
    isPopupOpen,
    openPopup,
    closePopup,
    setupCloseOnFocusLoss,
    setupTriggerExpandedState,
}